import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CopyToClipboardService {
  async copy(value: string): Promise<void> {
    return new Promise((resolve, error) => {
      if (!navigator.clipboard) {
        return error('No navigator available to copy to clipboard: ' + value);
      }
      
      return navigator.clipboard.writeText(value)
      .then(() => resolve())
      .catch(err => error('Failed to copy to clipboard: ' + err));
    });
  }
}
